import { Controller } from "remult";

@Controller("volunteer-org-project-assignment-methods")
export class VolunteerOrgProjectAssignmentMethods {}
